import { resolveEffectiveSlipContext, normalizeOddsToHitPercent, isExplicitSlipTypePlatform } from "../props-slip-breakevens";
import { probabilityToAmerican } from "@/lib/multibook/avg";
import type { DisplayPlayerProp, PlatformType } from "./types";

export function applySlipEdgeMetrics(
  prop: DisplayPlayerProp,
  rowSportsbook: string,
  options?: {
    platform?: PlatformType;
    slipTypeId?: string | null;
    boostPct?: number;
    standardDecimal?: number | null;
    league?: string | null;
  },
): void {
  const slipPlatform = (options?.platform ?? rowSportsbook) as PlatformType;
  const fairWinPct = normalizeOddsToHitPercent(prop.odds_to_hit);
  const slipCtx = resolveEffectiveSlipContext({
    platform: slipPlatform,
    rawSlipTypeId: options?.slipTypeId ?? null,
    americanOdds: prop.primary_odds,
    fairWinPct,
    boostPct: options?.boostPct ?? 0,
    standardDecimal: options?.standardDecimal ?? null,
    league: options?.league ?? prop.league ?? null,
  });
  prop.edge_percentage = slipCtx.edgePct;
  prop.effective_slip_type_id = slipCtx.effectiveSlipTypeId;
  prop.effective_slip_type_label = slipCtx.effectiveSlipTypeLabel;
  prop.effective_slip_breakeven_pct = slipCtx.effectiveBreakevenPct;
  prop.used_implicit_best_slip = slipCtx.usedImplicitBestSlip;
  prop.slip_implied_odds =
    !slipCtx.usedImplicitBestSlip && slipCtx.effectiveBreakevenPct != null && slipCtx.effectiveBreakevenPct > 0
      ? probabilityToAmerican(slipCtx.effectiveBreakevenPct / 100)
      : null;

  if (isExplicitSlipTypePlatform(slipPlatform) && fairWinPct != null && slipCtx.effectiveBreakevenPct != null && slipCtx.effectiveBreakevenPct > 0) {
    const slipEv = (fairWinPct / slipCtx.effectiveBreakevenPct - 1) * 100;
    prop.ev_percentage = Math.round(slipEv * 10) / 10;
    prop.ev_roi = prop.ev_percentage;
  }
}
